/** Matches {@link StickyStatesData.inactiveEvent} in sticky-states-util.js. */
const STICKY_STATES_INACTIVE_EVENT = "sticky-states-inactive";

export type StickyStatesInactiveMap = Record<string, boolean>;

/**
 * TypeScript subscription to ui-router sticky-state inactivation broadcasts
 * (replaces per-view AngularJS `$scope.$on(StickyStatesData.inactiveEvent, …)`).
 */
export class StickyStatesBridge {
    private static readonly subscribers = new Set<(inactiveMap: StickyStatesInactiveMap) => void>();
    private static rootScopeRegistered = false;

    static subscribe(handler: (inactiveMap: StickyStatesInactiveMap) => void): () => void {
        StickyStatesBridge.ensureRootScopeListener();
        StickyStatesBridge.subscribers.add(handler);
        return () => StickyStatesBridge.subscribers.delete(handler);
    }

    private static ensureRootScopeListener(): void {
        if (StickyStatesBridge.rootScopeRegistered) {
            return;
        }
        const rootScope = window.angBridge?.$rootScope as
            | { $on?: (event: string, listener: (...args: unknown[]) => void) => () => void }
            | undefined;
        if (!rootScope?.$on) {
            return;
        }
        StickyStatesBridge.rootScopeRegistered = true;
        rootScope.$on(STICKY_STATES_INACTIVE_EVENT, (_event: unknown, inactiveMap: unknown) => {
            const map = (inactiveMap ?? {}) as StickyStatesInactiveMap;
            for (const subscriber of StickyStatesBridge.subscribers) {
                subscriber(map);
            }
        });
    }
}
